import React, { type ComponentPropsWithoutRef } from 'react';

const ConditionalProfileCard = importCond<
	typeof import('./main.tsx'),
	typeof import('./async.tsx')
>('empanada_team_profilecard_trial_sync_trigger', './main.tsx', './async.tsx');

// inline this into usages when cleaning up empanada_team_profilecard_trial_sync_trigger
export default function ProfileCard(
	props: ComponentPropsWithoutRef<typeof ConditionalProfileCard>,
) {
	return <ConditionalProfileCard {...props} />;
}
